import { createSelector } from 'reselect';
import get from 'lodash/get';
import baseSelector from '../base/selectors';
import commonSelector, {
  selectedCustomerIdSelector,
} from '../../common/selectors';

import { SCOPE } from './types';

const selector = state => get(state, SCOPE);

export default selector;

export const sharingSelector = createSelector(
  commonSelector,
  selectedCustomerIdSelector,
  baseSelector,
  (
    commonStore,
    selectedCustomerId,
    baseStore,
  ) => {
    const dashboard = 'ovb';
    const {
      interval,
    } = commonStore;
    const start = interval.from;
    const end = interval.to;
    const title = 'Overview Sharing';
    return {
      title,
      dashboard,
      start,
      end,
      state: {
        common: {
          selectedCustomerId,
        },
        ovbStore: baseStore,
      },
    };
  },
);

export const sharingResponseSelector = createSelector(
  selector,
  (store) => {
    const { response } = store;
    if (!response) {
      return null;
    }
    const { state, id } = response;
    return {
      state: JSON.parse(state),
      id,
    };
  },
);

export const sharingIsFetchingSelector = createSelector(
  selector,
  store => (store.isFetching),
);
